var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a-menu',{attrs:{"selectedKeys":[_vm.$route.name],"mode":"inline","theme":"dark","inline-collapsed":false},on:{"click":_vm.onRouteSelected}},[_c('a-menu-item',{key:"ModelProductList"},[_c('span',[_vm._v("产品列表")])]),_c('a-menu-item',{key:"ModelLoadDeviceList"},[_c('span',[_vm._v("负载类型列表")])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }